(function () {
  'use strict';

  angular
    .module('doubleSectorPriorToDayTurnaround')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('doubleSectorPriorToDayTurnaround', {
        url: '/double-sector-prior-to-day-turnaround',
        views: {
          'doubleSectorPriorToDayTurnaroundView': {
            templateUrl: 'double-sector-prior-to-day-turnaround/views/double-sector-prior-to-day-turnaround.tpl.html',
            controller: 'doubleSectorPriorToDayTurnaroundCtrl',
            controllerAs: 'doubleSectorPriorToDayTurnaround'
          }
        }
      });
  }
}());
